// Decision 0020 (AURANE_PHARES): the Beacon's expedition and the ancient relays, in the system panel. Shown only when the
// server runs the rule (`v.me.phares` is present); otherwise the panel keeps the old "Light the Beacon" button.
import type { PlayerView, SystemView } from '@aurane/sim';
import { act } from '../net.js';
import { t } from '../i18n/index.js';
import { hms } from './bits.js';

/** The old button when the rule is off; with it on, the trial's three states: ready, open, resting. */
export function BeaconControls({ v, s }: { v: PlayerView; s: SystemView }) {
  const ph = v.me.phares;
  if (s.kind !== 'beacon' || s.owner !== v.me.id || s.lit) return null;
  if (!ph || !s.byExpedition) return <button onClick={() => void act({ type: 'light_beacon', system: s.id })}>{t('lightBeacon')}</button>;
  const trial = ph.trial;
  if (trial?.kind === 'beacon' && trial.system === s.id) {
    return (
      <span class="phares-trial">
        <span class="tag">{t('pharesOpen')}</span>
        {!trial.expedition && <button onClick={() => void act({ type: 'expedition_trial_cancel' })}>{t('pharesCancel')}</button>}
      </span>
    );
  }
  const retry = ph.retryAt[s.id] ?? 0;
  if (retry > v.time) return <span class="tag">{t('pharesRest').replace('{h}', hms(retry - v.time))}</span>;
  return <button class="primary" disabled={!!trial} onClick={() => void act({ type: 'beacon_expedition_open', system: s.id })}>{t('pharesLight')}</button>;
}

/** Ancient relays found in the system (to wake) or woken. */
export function AncientRelays({ v, s }: { v: PlayerView; s: SystemView }) {
  if (!v.me.phares || !s.ancient) return null;
  const busy = !!v.me.phares.trial;
  return (
    <div class="phares-ancient">
      {s.ancient.woken.length > 0 && <p class="small">{'◆ '}{t('ancientWoken')}</p>}
      {s.ancient.found.map((poi) => (
        <p key={poi} class="small">
          {'◇ '}{t('ancientFound')}
          <button disabled={busy} onClick={() => void act({ type: 'relay_expedition_open', system: s.id, poi })}>{t('ancientWake')}</button>
        </p>
      ))}
    </div>
  );
}
